import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// Site-wide banner shown to logged-in users whose approval_status !== 'approved'.
// Renders nothing for guests, admins, or approved users. Polls /api/users/me
// once per mount + on focus so the banner clears as soon as the admin approves.

const tokenHdr = () => {
  const t = localStorage.getItem('token') || localStorage.getItem('authToken');
  return t ? { Authorization: `Bearer ${t}` } : null;
};

export default function ApprovalBanner() {
  const [me, setMe] = useState(null);
  useEffect(() => {
    const load = async () => {
      const h = tokenHdr();
      if (!h) { setMe(null); return; }
      try {
        const r = await fetch('/api/users/me', { headers: h });
        if (r.ok) setMe(await r.json());
      } catch (_) {}
    };
    load();
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);

  if (!me || !me.approval_status || me.approval_status === 'approved') return null;

  const map = {
    pending: {
      bg: '#fff8e1', color: '#92400e',
      title: 'Account pending approval',
      body: 'Complete your application so we can review and unlock pricing + checkout.',
      cta: 'Complete application →',
    },
    needs_info: {
      bg: '#fef3c7', color: '#92400e',
      title: 'We need a bit more info',
      body: me.rejection_reason || 'A team member requested more details on your application. Update and resubmit to continue.',
      cta: 'Update application →',
    },
    rejected: {
      bg: '#fee2e2', color: '#991b1b',
      title: 'Application not approved',
      body: me.rejection_reason || 'Your application was not approved. You can resubmit with updated information.',
      cta: 'Resubmit →',
    },
  };
  const v = map[me.approval_status] || map.pending;

  return (
    <div role="alert" style={{
      background: v.bg, color: v.color,
      padding: '10px 16px',
      borderBottom: `1px solid ${v.color}22`,
      display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap',
      fontSize: 14,
    }}>
      <strong>{v.title}</strong>
      <span style={{ flex: 1, minWidth: 200 }}>{v.body}</span>
      <Link to="/apply" style={{ color: v.color, fontWeight: 600, textDecoration: 'underline' }}>
        {v.cta}
      </Link>
    </div>
  );
}
